export const STATUS_LABELS = {
  NEW: "New",
  PRE_SCREENING: "Pre-Screening",
  UNDER_REVIEW: "Under Review",
  COMMERCIAL_CONTACT: "Commercial Contact",
  SELECTED: "Selected",
  NOT_SELECTED: "Not Selected",
  WAITLIST: "Waitlist",
};

export const STATUS_ORDER = ["NEW", "PRE_SCREENING", "UNDER_REVIEW", "COMMERCIAL_CONTACT", "SELECTED", "NOT_SELECTED", "WAITLIST"];

const STATUS_STYLE = {
  NEW: "border-ivory/30 text-ivory/80",
  PRE_SCREENING: "border-sky-400/40 text-sky-300",
  UNDER_REVIEW: "border-gold/50 text-gold",
  COMMERCIAL_CONTACT: "border-amber-400/40 text-amber-300",
  SELECTED: "border-emerald-400/50 text-emerald-300",
  NOT_SELECTED: "border-red-400/40 text-red-300",
  WAITLIST: "border-purple-400/40 text-purple-300",
};

export function StatusBadge({ status, className = "" }) {
  return (
    <span className={`inline-flex items-center px-3 py-1 border text-[10px] tracking-[0.18em] uppercase ${STATUS_STYLE[status] || "border-ivory/30 text-ivory/70"} ${className}`} data-testid={`status-badge-${status}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export const INV_STYLE = {
  ACTIVE: "border-emerald-400/50 text-emerald-300",
  USED: "border-gold/50 text-gold",
  EXPIRED: "border-ivory/25 text-ivory/50",
  DISABLED: "border-red-400/40 text-red-300",
};

export function AdminCard({ children, className = "" }) {
  return <div className={`bg-navy-800 border border-ivory/10 ${className}`}>{children}</div>;
}
